import React from 'react';
import { VCycleElementType } from '../../../../resource/enumerations/VCycleElementType';
import {
    useVCycleElementActions,
    VCycleElementParentRelation,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementResource';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { isArray } from 'lodash';

export const NumberOfElementsInput= ({ parentId, parentType }: {
    parentId: string,
    parentType: VCycleElementType
}) => {

    const vcycleElementActions = useVCycleElementActions()
    const parentRelation = parentType === VCycleElementType.PROCESS_AREA ? VCycleElementParentRelation.PROCESS_AREA_V_CYCLE_ELEMENT_CONTAINER :
        VCycleElementParentRelation.V_CYCLE_REPRESENTATION_V_CYCLE_ELEMENT_CONTAINER
    const vcycleElementsQuery = vcycleElementActions.useGetAllOrSingleResources(parentRelation, parentId);

    const getSize = () => {
        if (vcycleElementsQuery.data && isArray(vcycleElementsQuery.data)) {
            return vcycleElementsQuery.data.length
        } else if (vcycleElementsQuery.data) {
            return 1
        }
        return 0
    }

    return (
        <ControlledInputs.Number
            value={getSize()}
            nullable={false}
            readOnly={true}
        />
    );
};